import { Component, ViewChild, OnInit } from '@angular/core';
import { Platform, Menu, NavController, MenuController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { GoogleAnalytics } from '@ionic-native/google-analytics/ngx';
import { AndroidPermissions } from '@ionic-native/android-permissions/ngx';

import { HomepageComponent } from '../pages/home/home';
import { RapportSansAccesComponent } from '../pages/rapport-sans-acces/rapport-sans-acces';
import { ConnexionComponent } from '../pages/connexion/connexion';
import { SavoirPlusComponent } from '../pages/savoir-plus/savoir-plus';
import { ListeElementsVerifiesComponent } from '../pages/liste-elements-verifies/liste-elements-verifies';
import { ElementVerifieComponent } from '../pages/element-verifie/element-verifie';
import { RapportComponent } from '../pages/rapport/rapport';
import { DerniersScansComponent } from '../pages/derniers-scans/derniers-scans';

import { AuthService } from './shared/services/auth.service';
import { LastScansService } from './shared/services/lastScans.service';
import { qrCodeService } from './shared/services/qrCode.service';

import { API } from './config';

@Component({
    templateUrl: 'app.html'
})
export class MyApp implements OnInit {
    private isApp: boolean;
    private rootPage:any;
    private hasLastScans: boolean = false;
    private user: string = '';

    @ViewChild('content') content: NavController;
    @ViewChild(Menu) menu: Menu;

    constructor(
    private platform: Platform,
     private menuCtrl: MenuController,
     private statusBar: StatusBar,
     private splashScreen: SplashScreen,
     private ga: GoogleAnalytics,
     private androidPermissions: AndroidPermissions,
     private authService: AuthService,
     private lastScansService: LastScansService,
     private qrCodeService: qrCodeService,
     private api: API
    ) {        
        this.platform.ready().then(async () => {
            setTimeout(() => {
                this.splashScreen.hide();
            }, 100);

            this.statusBar.overlaysWebView(false);
            this.statusBar.backgroundColorByHexString('#000');

            if (this.platform.is('core') || this.platform.is('mobileweb')) {
                this.isApp = false;
                // Google Analytics
                this.ga.startTrackerWithId("UA-103833510-3");
                var scanId = this.platform.getQueryParam('id');
                if (scanId != undefined) {
                    const token = await this.authService.getToken();
                    this.user = (token !== null) ? token.user : '';
                    const urlQRCode = this.api.qrCodeURL + '?id=' + scanId;
                    if (this.user != '') {
                        this.qrCodeService.getScanQRCode(urlQRCode).subscribe(
                            async (scan) => {
                                await this.lastScansService.setLastScans(this.user, scan);
                                if (urlQRCode.match("socotec")) {
                                    this.ga.trackEvent("QRCode valide SOCOTEC", "scan");
                                } else {
                                    this.ga.trackEvent("QRCode valide Non SOCOTEC", "scan");
                                }
                                if (scan.qrCodeType == "Installation") {
                                    this.goToPage({ page: 'rapport' });
                                } else {
                                    this.goToPage({ page: 'element-verifie' });
                                }
                            }, 
                            (error) => {
                                console.error(error);
                                if (error.status == 403) {
                                    this.ga.trackEvent("QRCode permission refusée", "scan");
                                } else if (error.status == 404) {
                                    this.ga.trackEvent("QRCode invalide", "scan");
                                }
                            }
                        );
                    } else {
                        this.qrCodeService.getScanQRCode(urlQRCode).subscribe(
                            (scan) => {
                                console.log(scan);
                                if (urlQRCode.match("socotec")) {
                                    this.ga.trackEvent("QRCode valide SOCOTEC", "scan");
                                }  else {
                                    this.ga.trackEvent("QRCode valide Non SOCOTEC", "scan");
                                }
                                this.goToPage({ page: 'rapport-sans-acces', data: scan });
                            },
                            (error) => {
                                console.error(error);
                                if (error.status == 403) {
                                    this.ga.trackEvent("QRCode permission refusée", "scan");
                                } else if (error.status == 404) {
                                    this.ga.trackEvent("QRCode invalide", "scan");
                                }
                            }
                        );
                    }
                }
            } else {
                this.isApp = true;
                // Google Analytics
                this.ga.startTrackerWithId("UA-103833510-1");
            }

            this.rootPage = HomepageComponent;
            this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.CAMERA).then(
                success => console.log('Permission granted'),
                err => this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.CAMERA)
            );
            this.androidPermissions.requestPermissions([this.androidPermissions.PERMISSION.CAMERA, this.androidPermissions.PERMISSION.GET_ACCOUNTS]);
        });
    }

    ngOnInit() {
        this.menuCtrl.enable(true, 'unauthenticated');
        this.menuCtrl.enable(false, 'authenticated');
        this.isAuthent();
    }

    async isAuthent() {
        const refreshToken = await this.authService.getRefreshToken();
        if(refreshToken != null) {
            const token = await this.authService.getToken();
            if (token != null) {
                this.menuCtrl.enable(false, 'unauthenticated');
                this.menuCtrl.enable(true, 'authenticated');
            }
        } else {
            await this.authService.removeToken();
        }
    }

    emitHasLastScans(event) {
        this.hasLastScans = event;
    }

    async goToPage(event) {
        let page = event.page;
        let data = event.data;
        // On redirige vers la bonne page
        if (page == 'rapport-sans-acces') {
            await this.authService.removeToken();
            await this.authService.removeRefreshToken();
            this.menuCtrl.enable(true, 'unauthenticated');
            this.menuCtrl.enable(false, 'authenticated');
            this.content.setRoot(RapportSansAccesComponent, { data: data });
        } else if (page == 'connexion') {
            this.content.setRoot(ConnexionComponent, data);
        } else if (page == 'deconnexion') {
            await this.authService.removeToken();
            await this.authService.removeRefreshToken();
            this.menuCtrl.enable(true, 'unauthenticated');
            this.menuCtrl.enable(false, 'authenticated');
            this.content.setRoot(HomepageComponent);
        } else if (page == 'savoir-plus') {
            this.content.push(SavoirPlusComponent);
        } else if (page == 'derniers-scans') {
            this.content.setRoot(DerniersScansComponent);
        } else if (page == 'liste-elements-verifies') {
            this.content.setRoot(ListeElementsVerifiesComponent, { rapportId: data });
        } else if (page == 'element-verifie') {
            let donnees = (data != null) ? { equipmentId: data.equipmentId, rapportId: data.rapportId } : {};
            this.content.setRoot(ElementVerifieComponent, donnees);
        } else if (page == 'rapport') {
            let donnees = (data != null) ? { rapportId: data } : {};
            this.content.setRoot(RapportComponent, donnees);
        } 
        // On ferme le menu
        this.menuCtrl.close();
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts